import React from 'react';
import ImportantBlock from '../../components/landing/ImportantBlock/ImportantBlock';
import Lead from '../../components/landing/Lead/Lead';
import MainSteps from '../../components/landing/MainSteps/MainSteps';
import InfoAboutService from '../../components/layout/InfoAboutService/InfoAboutService';

function MainPage() {
  return (
    <React.Fragment>
      <Lead />
      <MainSteps />
      <InfoAboutService />
      <ImportantBlock />
    </React.Fragment>
  );
}

export default MainPage;
